import { onBeforeMount, ref } from 'vue'

export function useShowShareLink() {
  const showShareLink = ref(false)

  onBeforeMount(() => {
    const url = new URL(window.location.href)
    showShareLink.value = url.searchParams.get('showShareLink') === 'true'
  })

  return { showShareLink }
}
